// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + "component---src-lekoarts-gatsby-theme-cara-templates-cara-tsx" + "-" + "ce525ff709eb6f99a196" + ".js";
};